import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { filterLocationUrl } from '../../Config/config';
import { PeFilterContext } from '../../Contexts/PeFilterContext';
import { TableHeaderContext } from '../../Contexts/TableHeaderContext';
import { UserContext } from '../../Contexts/UserContext';
import AcquirerDealRangeFilter from '../RefineSearchComponents/AcquirerDealRangeFilter';
import CityFilter from '../RefineSearchComponents/CityFilter';
import SubsectorFilter from '../RefineSearchComponents/SubSector';
import Constants from '../../Constants';
import ToggleButton from "../RefineSearchComponents/ToggleAndOrSwitch";
import LAdvisor from '../RefineSearchComponents/lAdvisor';
import TAdvisor from '../RefineSearchComponents/tAdvisor';
import TargetCompany from '../RefineSearchComponents/TargetCompany';
import Investor from "../RefineSearchComponents/Investor";
import Acquirers from "../RefineSearchComponents/Acquirers";
import { IoMdArrowDropdown, IoMdArrowDropright } from "react-icons/io";

/**
 * The function `ReInvestorExitRefineSearch` is a React component that renders a form for refining
 * search filters and applying them to a custom pathname.
 * @returns a JSX element, which represents the UI of the component.
 */
function ReInvestorExitRefineSearch({ customPathname, dataPath, menu, generalPathname }) {
    const location = useLocation();
    const navigate = useNavigate();
    const { pathname } = useLocation(); 
    const isFromGlobalSearch = ()=> refineSearchFilters[pathname]?.globalSearch?.length > 0 ? true : false
    const isFromSearchedList = ()=> refineSearchFilters[location?.state?.prevPath]?.globalSearch?.length > 0 ? true : false
    const { setrefineSearchFilters, onErrorHandler, refineSearchFilters, MinAcquirerDealRange, MaxAcquirerDealRange ,setMonthPickerValue , SwitchState,setSwitchState,
        InvestorOptions ,dbDropdown , setDbDropdown , setInvestorOptions ,AcquirersOptions , setAcquirersOptions ,
        lAdvisorsOptions,setlAdvisorsOptions,isMobile,setOpen,open,tAdvisorsOptions , settAdvisorsOptions , TargetCompanyOptions , setTargetCompanyOptions ,dropdown} = useContext(PeFilterContext);
    const { setSelectedPage } = useContext(TableHeaderContext);
    const { getToken } = useContext(UserContext);
    const [select, setSelected] = useState(32);

    // State for managing which filter section is active
    const [activeFilterSection, setActiveFilterSection] = useState("keyword");
    
    // State for managing which individual filter popup is open
    const [openFilterPopup, setOpenFilterPopup] = useState(null);

    const [SubSectorOptions, setSubSectorOptions] = useState([])
    const [MinDealRangeOptions, setMinDealRangeOptions] = useState([])
    const [MaxDealRangeOptions, setMaxDealRangeOptions] = useState([])
    const [CityOptions, setCityOptions] = useState([])


  /**
   * The function `applyFilter` updates the refine search filters based on the selected subsector,
   * cities, and deal range options.
   */
    const applyFilter = () => {
        const selectedSubsector = SubSectorOptions?.filter(option => option.isChecked);
        const selectedCities = CityOptions?.filter(option => option.isChecked);
        const minDealRange = MinDealRangeOptions?.filter(option => option.isChecked)?.at(0) ?? null;
        const maxDealRange = MaxDealRangeOptions?.filter(option => option.isChecked)?.at(0) ?? null;
        const selectedOperators = SwitchState;
        const selectedlAdvisors = lAdvisorsOptions?.filter(option => option.isChecked);
        const selectedtAdvisors = tAdvisorsOptions?.filter(option => option.isChecked);
        const selectedTargetCompany = TargetCompanyOptions?.filter(option => option.isChecked); 
        const selectedInvestor = InvestorOptions?.filter(option => option.isChecked); 
        const selectedAcquirers = AcquirersOptions?.filter(option => option.isChecked); 

        setrefineSearchFilters(prev => ({
            ...prev,
            [generalPathname]:{
                ...prev[generalPathname],
                dealRange: minDealRange != null && maxDealRange != null ? [minDealRange, maxDealRange] : [],
                city: selectedCities,
            },
            [customPathname]: {
                ...prev[customPathname],
                subSector: selectedSubsector,
                deals_operator : selectedOperators,
                ladvisors: selectedlAdvisors,
                tadvisors: selectedtAdvisors,
                investor_id : customPathname.includes("/re/advisors/re-investments") || customPathname.includes("/re/transaction-advisors/other-ma") ? selectedAcquirers  :  selectedInvestor ,
                target_company:selectedTargetCompany,
            },
        }))
    }

   /**
    * The function `resetFilter` resets a specific filter in the `refineSearchFilters` state object by
    * setting its value to an empty object.
    */
    const resetFilter = () => {
        
        setrefineSearchFilters(prev => ({
            ...prev,
            [generalPathname]:{},
            [customPathname]: {}
        }))
        setlAdvisorsOptions([]);
        settAdvisorsOptions([]);
        setTargetCompanyOptions([]);
        setInvestorOptions([]);
        setAcquirersOptions(AcquirersOptions.map(option => {
            if (option.isChecked) {
                return { ...option, isChecked: false };
            }
            return option;
        })
    )
    }


    // Submitting Refine Search Form 
  /**
   * The function `refineSearchFilter` updates search filters, resets certain values, and applies the
   * filter.
   * @param event - The event parameter is an object that represents the event that triggered the
   * function. It contains information about the event, such as the type of event, the target element,
   * and any additional data associated with the event. In this case, the event is being used to
   * prevent the default behavior of a form submission
   */
    const refineSearchFilter = (event) => {
        if(isMobile){
            setOpen(!open);
        }
        event.preventDefault();
        setrefineSearchFilters(prev => ({
            ...prev,
            [generalPathname]:{},
            [customPathname]: {globalSearch:[],
            }
        }))
        if(isFromGlobalSearch() || isFromSearchedList()){
            setMonthPickerValue(Constants.initialMonthRange)
        }
        setSelectedPage(1);
        applyFilter();
        setSelected(0)
        if (location.pathname != customPathname) {
            navigate(customPathname)
        }

    }

  /**
   * The `onResetClick` function resets the selected page, resets the filter, and navigates to a custom
   * pathname if the current pathname is not already the custom pathname.
   * @param event - The event parameter is an object that represents the event that triggered the
   * function. In this case, it is the click event that occurred when the user clicked on a reset
   * button or element.
   */
    const onResetClick = (event) => {
        event.preventDefault();
        setSelectedPage(1);
        resetFilter()
        if (location.pathname != customPathname) {
            navigate(customPathname)
        }
    }

  /**
   * The function `accordionClick` sets the selected value to 0 if it is equal to `select`, otherwise
   * it sets it to the provided value.
   * @param val - The `val` parameter is a value that is passed to the `accordionClick` function. It is
   * used to determine whether the accordion should be selected or deselected.
   */
    const accordionClick = (val) => {
        if (val === select) {
            setSelected(0);
        } else {
            setSelected(val);
        }
    };

    useEffect(() => {

        const cityIds = refineSearchFilters[generalPathname]?.city?.map(value => value.id) ?? [];

        axios.post(filterLocationUrl, {
            country: [],
            region: [],
            state: [],
            city: [],

        }, {
            headers: {
                "Authorization": getToken()
            }
        }).then(response => {
            if (response.status === 200) {
                setCityOptions(response.data.city?.map(option => ({ ...option, isChecked: cityIds.includes(option.id) })))
            }
        }).catch(onErrorHandler)
    }, [refineSearchFilters])


    const toggleSwitchState = () => {
        setSwitchState(prevState => prevState === "and" ? "or" : "and");
    };

    const handleDbToggle = () => {
        setDbDropdown(!dbDropdown);
    };

    // Helper functions to count applied filters for each section
    const getDealFiltersCount = () => {
        let count = 0;
        if ((MinDealRangeOptions?.length > 0 && MinDealRangeOptions.some(option => option.isChecked)) || (MaxDealRangeOptions?.length > 0 && MaxDealRangeOptions.some(option => option.isChecked))) count++;
        if (SubSectorOptions?.length > 0 && SubSectorOptions.some(option => option.isChecked)) count++;
        return count;
    };

    const getCompanyFiltersCount = () => {
        let count = 0;
        if (CityOptions?.length > 0 && CityOptions.some(option => option.isChecked)) count++;
        return count;
    };

    const getKeywordFiltersCount = () => {
        let count = 0;
        if (InvestorOptions?.length > 0 && InvestorOptions.some(option => option.isChecked)) count++;
        if (AcquirersOptions?.length > 0 && AcquirersOptions.some(option => option.isChecked)) count++;
        if (TargetCompanyOptions?.length > 0 && TargetCompanyOptions.some(option => option.isChecked)) count++;
        if (lAdvisorsOptions?.length > 0 && lAdvisorsOptions.some(option => option.isChecked)) count++;
        if (tAdvisorsOptions?.length > 0 && tAdvisorsOptions.some(option => option.isChecked)) count++;
        return count;
    };

    return (
        <div className="bg-white">
            <div className="h-full flex flex-col">
                <form onSubmit={refineSearchFilter} onReset={onResetClick} className="min-h-full w-full flex flex-col">
                    <main className="flex-1 w-full py-4 overflow-y-auto">
                        <div className="flex flex-col md:grid md:grid-cols-8 gap-2 md:gap-4 h-full">
                            {/* Left column - Section Headers */}
                            <div className="flex flex-row md:flex-col gap-1 md:gap-2 border-b md:border-b-0 md:border-r border-gray-300 pb-2 md:pb-0 md:pr-4 md:max-w-[320px] md:col-span-2 items-baseline md:items-stretch overflow-x-auto no-scrollbar flex-wrap md:flex-nowrap mt-0 md:mt-4">

                                {/* Keyword Search Section */}
                                <div 
                                    className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors flex-shrink-0 whitespace-nowrap min-w-fit ${
                                        activeFilterSection === 'keyword' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'keyword' ? null : 'keyword')}
                                >
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center gap-1 md:gap-2">
                                            <span className="text-xs md:text-base font-medium">Keyword Search</span>
                                            {getKeywordFiltersCount() > 0 && (
                                                <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] text-center ${activeFilterSection === 'keyword' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                    {getKeywordFiltersCount()}
                                                </span>
                                            )}
                                        </div>
                                        {activeFilterSection === 'keyword' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                    </div>
                                </div>

                                {/* Deal Section */}
                                <div 
                                    className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors flex-shrink-0 whitespace-nowrap min-w-fit ${
                                        activeFilterSection === 'deal' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'deal' ? null : 'deal')}
                                >
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center gap-1 md:gap-2">
                                            <span className="text-xs md:text-base font-medium">Deal</span>
                                            {getDealFiltersCount() > 0 && (
                                                <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] text-center ${activeFilterSection === 'deal' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                    {getDealFiltersCount()}
                                                </span>
                                            )}
                                        </div>
                                        {activeFilterSection === 'deal' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                    </div>
                                </div>

                                {/* Company Section */}
                                <div 
                                    className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors flex-shrink-0 whitespace-nowrap min-w-fit ${
                                        activeFilterSection === 'company' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'company' ? null : 'company')}
                                >
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center gap-1 md:gap-2">
                                            <span className="text-xs md:text-base font-medium">Company</span>
                                            {getCompanyFiltersCount() > 0 && (
                                                <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] text-center ${activeFilterSection === 'company' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                    {getCompanyFiltersCount()}
                                                </span>
                                            )}
                                        </div>
                                        {activeFilterSection === 'company' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                    </div>
                                </div>

                            </div>
                            
                            {/* Right column - Filter Content */}
                            <div className="overflow-y-auto no-scrollbar md:overflow-visible mt-0 md:mt-4 h-full md:h-auto md:max-h-none pb-20 md:pb-0 md:col-span-6">
                                {/* Deal Content */}
                                <div className={`grid grid-cols-1 sm:grid-cols-2 gap-4 gap-y-4 ${activeFilterSection === 'deal' ? '' : 'hidden'}`}>
                                    <AcquirerDealRangeFilter
                                        customPathname={generalPathname}
                                        MinDealOptions={MinDealRangeOptions}
                                        setMinDealOptions={setMinDealRangeOptions}
                                        MaxDealOptions={MaxDealRangeOptions}
                                        setMaxDealOptions={setMaxDealRangeOptions}
                                        MinDealRange={MinAcquirerDealRange}
                                        MaxDealrange={MaxAcquirerDealRange}
                                        label="Deal Range (US $M)"
                                        isPopupOpen={openFilterPopup === 'dealRange'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'dealRange' : null)}
                                    />
                                    <SubsectorFilter
                                        options={SubSectorOptions}
                                        setOptions={setSubSectorOptions}
                                        customPathname={customPathname}
                                        dataPath={dataPath}
                                    />
                                </div>

                                {/* Company Content */}
                                <div className={`grid grid-cols-1 sm:grid-cols-2 gap-4 gap-y-4 ${activeFilterSection === 'company' ? '' : 'hidden'}`}>
                                    <CityFilter
                                        CityOptions={CityOptions}
                                        setCityOptions={setCityOptions}
                                        customPathname={generalPathname}
                                        label="City (of Target Company)"
                                        isPopupOpen={openFilterPopup === 'city'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'city' : null)}
                                    />
                                </div>

                                {/* Keyword Search Content */}
                                <div className={`w-full md:w-1/2 mt-4 md:mt-0 md:mb-0 ${activeFilterSection === 'keyword' ? '' : 'hidden'}`}>
                                    <div className="space-y-4">
                                        {(customPathname.includes("/re/advisors/other-ma") || customPathname.includes("/re/transaction-advisors/other-ma")) ? (
                                            <Acquirers 
                                                options={AcquirersOptions}
                                                setOptions={setAcquirersOptions}
                                                customPathname={customPathname}
                                                label="Acquirers"
                                                menu={menu}
                                            />
                                        ) : (
                                            <Investor 
                                                options={InvestorOptions}
                                                setOptions={setInvestorOptions}
                                                customPathname={customPathname}
                                                label="Investor"
                                                menu={menu}
                                            />
                                        )}

                                        <TargetCompany 
                                            options={TargetCompanyOptions}
                                            setOptions={setTargetCompanyOptions}
                                            customPathname={customPathname}
                                            label="Company"
                                            menu={menu}
                                        />

                                        {(customPathname.includes("/re/advisors/") || customPathname.includes("/re/transaction-advisors/")) ? (
                                            <>
                                                {customPathname.includes("/re/advisors/") && (
                                                    <LAdvisor 
                                                        options={lAdvisorsOptions}
                                                        setOptions={setlAdvisorsOptions}
                                                        customPathname={customPathname}
                                                        label="Legal Advisors"
                                                        menu={menu}
                                                    />
                                                )}
                                                {customPathname.includes("/re/transaction-advisors/") && (
                                                    <TAdvisor 
                                                        options={tAdvisorsOptions}
                                                        setOptions={settAdvisorsOptions}
                                                        label="Transaction Advisors"
                                                        customPathname={customPathname}
                                                        menu={menu}
                                                    />
                                                )}
                                            </>
                                        ) : customPathname.includes("/re/investors/exits") && (
                                            <>
                                                <LAdvisor 
                                                    options={lAdvisorsOptions}
                                                    setOptions={setlAdvisorsOptions}
                                                    customPathname={customPathname}
                                                    label="Legal Advisors"
                                                    menu={menu}
                                                />
                                                <TAdvisor 
                                                    options={tAdvisorsOptions}
                                                    setOptions={settAdvisorsOptions}
                                                    label="Transaction Advisors"
                                                    customPathname={customPathname}
                                                    menu={menu}
                                                />
                                            </>
                                        )}
                                    </div>
                                </div>

                                {/* No section selected */}
                                <div className={`flex items-center justify-center h-40 text-gray-500 ${activeFilterSection ? 'hidden' : ''}`}>
                                    <p>Select a filter category from the left to view available filters</p>
                                </div>
                            </div>
                        </div>

                    </main>
                </form>
            </div>
        </div>
    )
}

export default ReInvestorExitRefineSearch
